export class ApiHelper {

  public static saveClientRequest: string = 'saveClientRequest' ;

}
